var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ix-section',[_c('ix-section-text',[_c('eu-taxonomy-alignment-outro',{attrs:{"questionnaire-assignment":_vm.questionnaire?.questionnaireAssignment,"questionnaire-template":_vm.questionnaire?.questionnaireTemplate},on:{"nextSection":function($event){return _vm.$emit('nextSection')}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }